<div class="dashboard-card list-card">
  <div class="widget-header">
    <h5>
      Student Applications
    </h5>

		<div class="col-6">
			<div class="input-group">
				<input type="text" class="form-control" placeholder="Search Application" 
				aria-label="Institute ID" aria-describedby="button-addon2" [(ngModel)]="searchTerm"
				(keyup.enter)="onSearchChange()">
				<button class="btn btn-primary" type="button" id="button-addon2" (click)="onSearchChange()">Search</button>
			</div>
		</div>

		<button class="btn btn-sm btn-light py-0" data-bs-toggle="modal" data-bs-target="#frmBackdrop" 
			(click)="newClick()">
			+Add New
		</button>
  </div>

	<div class="w-100">
		<table class="table table-striped w-100">
      <thead>
        <tr>
          <th>#</th>
          <th>App. Date</th>
          <th>Code</th>
          <th>Name</th>
          <th>Parents</th>
          <th>Transport</th>
          <th>Eligible</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @for(data of allData; track $index; let idx = $index;) {
        <tr>
          <td>{{idx+1}}.</td>
          <td>{{dataService.ymd2dmy(data.reg_date)}}</td>
          <td>{{data.app_code}}</td>
          <td>{{data.std_name}}</td>
          <td>{{data.father_name || data.mother_name}}</td>
          <td>{{data.req_transport}}</td>
          <td>{{data.is_eligible}}</td>
          <td>{{data.is_active}}</td>
          <td>
            <div class="d-flex gap-3">
              <span style="cursor: pointer;" (click)="getEditData(data);" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight" title="View Details">
                <i class="bi bi-eye text-primary"></i>
              </span>

              <span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
                (click)="editClick(data)" title="Modify">
                <i class="bi bi-pencil-square text-success"></i>
              </span>

              <span style="cursor: pointer;" (click)="deleteClick(data.id)" title="Delete">
                <i class="bi bi-trash3 text-danger"></i>
              </span>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>

		<div class="text-danger" align="center" *ngIf="allData && !allData.length && !loading">
			<i class="bi bi-x-circle"></i> No data available.
		</div>

  </div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel"
	style="width: 500px;">
	<div class="offcanvas-header">
		<h5 class="offcanvas-title" id="offcanvasRightLabel">Student Details</h5>
		<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	</div>
	<div class="offcanvas-body" *ngIf="appData">
		<table class="table table-striped-columns">
			<tbody>
				@for(fld of tblFields; track fld;) {
					@if(appData && typeof appData[fld.field] !== 'object') {
					<tr>
						<td>{{fld.title}}</td>
						<td *ngIf="fld.field!='std_dob'">{{appData[fld.field]}}</td>
						<td *ngIf="fld.field=='std_dob'">{{dataService.ymd2dmy(appData[fld.field])}}</td>
					</tr>
					} @else {
					<tr>
						<td>
							@if(fld.field == 'std_info') {
								<div align="center">
									<div class="photo-preview">
										@if (appData.profile_photo) {
											<img [src]="appData.profile_photo" alt="Profile">
										}
									</div>
									{{appData.std_name}}
								</div>
							} @else {
								{{fld.title}}
							}
						</td>
						<td>
							@if(fld.field == 'std_info') {
								<table class="table mb-0"><tbody>
								<tr><td>Gender:</td><td>{{appData.std_info.gender}}</td></tr>
								<tr><td>Category:</td><td>{{appData.std_info.category}}</td></tr>
								<tr><td>Religion:</td><td>{{appData.std_info.religion}}</td></tr>
								<tr><td>Nationality:</td><td>{{appData.std_info.nationality || 'Indian'}}</td></tr>
								<tr><td>Aadhaar No.:</td><td>{{appData.std_info.aadhaarNumber}}</td></tr>
								</tbody></table>
							}
							@if(fld.field == 'f_info') {
								<table class="table mb-0"><tbody>
								<tr><td>Qualification:</td><td>{{appData.f_info.qualification}}</td></tr>
								<tr><td>Occupation:</td><td>{{appData.f_info.occupation}}</td></tr>
								<tr><td>Mobile No.:</td><td>{{appData.f_info.mobile}}</td></tr>
								<tr><td>Email ID:</td><td>{{appData.f_info.email}}</td></tr>
								<tr><td>Annual Income:</td><td>{{appData.f_info.annualIncome}}</td></tr>
								</tbody></table>
							}
							@if(fld.field == 'm_info') {
								<table class="table mb-0"><tbody>
								<tr><td>Qualification:</td><td>{{appData.m_info.qualification}}</td></tr>
								<tr><td>Occupation:</td><td>{{appData.m_info.occupation}}</td></tr>
								<tr><td>Mobile No.:</td><td>{{appData.m_info.mobile}}</td></tr>
								<tr><td>Email ID:</td><td>{{appData.m_info.email}}</td></tr>
								<tr><td>Annual Income:</td><td>{{appData.m_info.annualIncome}}</td></tr>
								</tbody></table>
							}
							@if(fld.field == 'g_info') {
								<table class="table mb-0"><tbody>
								<tr><td>Relation:</td><td>{{appData.g_info.relation}}</td></tr>
								<tr><td>Address:</td><td>{{appData.g_info.address}}</td></tr>
								<tr><td>Mobile No.:</td><td>{{appData.g_info.mobile}}</td></tr>
								<tr><td>Email ID:</td><td>{{appData.g_info.email}}</td></tr>
								</tbody></table>
							}
							@if(fld.field == 'addresses') {
								<table class="table mb-0"><tbody>
								<tr><td><b>Permanent:</b><br>
									#{{appData.addresses[0].houseNo}}, {{appData.addresses[0].street}},<br>
									{{appData.addresses[0].city}} - {{appData.addresses[0].pinCode}}<br>
									{{appData.addresses[0].state}}, {{appData.addresses[0].country}}.
								</td></tr>
								<tr><td><b>Correspondence:</b><br>
									#{{appData.addresses[1].houseNo}}, {{appData.addresses[1].street}},<br>
									{{appData.addresses[1].city}} - {{appData.addresses[1].pinCode}}<br>
									{{appData.addresses[1].state}}, {{appData.addresses[1].country}}.
								</td></tr>
								</tbody></table>
							}

							@if(fld.field == 'academics') {
								<table class="table mb-0"><tbody>
								<tr><td>Prev. School:</td><td>{{appData.academics.previousSchool}}</td></tr>
								<tr><td>Board:</td><td>{{appData.academics.board}}</td></tr>
								<tr><td>Passing Year:</td><td>{{appData.academics.passingYear}}</td></tr>
								<tr><td>Percentage:</td><td>{{appData.academics.percentage}}</td></tr>
								<tr><td>TC No:</td><td>{{appData.academics.tcNumber}}</td></tr>
								</tbody></table>
							}
							@if(fld.field == 'documents') {
								<table class="table mb-0"><tbody>
								@for(doc of appData.documents; track doc;) {
								<tr>
									<td>{{doc.label}}:</td>
									<td *ngIf="doc.file">
										<a href="{{auth.svrUrl}}/uploads/{{user.erp_key}}/std_docs/{{appData.app_code}}/{{doc.fileName}}" target="_blank">
											<i class="bi bi-file-earmark-check text-primary"></i>
										</a>
									</td>
									<td *ngIf="!doc.file"><i class="bi bi-file-earmark-excel text-danger"></i></td>
								</tr>
								}
								</tbody></table>
							}

							@if(fld.field == 'declaration') {
								<table class="table mb-0"><tbody>
								<tr><td>Accepted:</td><td>{{appData.declaration.accepted}}</td></tr>
								<tr><td>Place:</td><td>{{appData.declaration.place}}</td></tr>
								<tr><td>Date:</td><td>{{dataService.ymd2dmy(appData.declaration.date)}}</td></tr>
								</tbody></table>
							}

						</td>
					</tr>
					}
				}
			</tbody>
		</table>

		<!-- <div class="w-100 d-flex justify-content-center gap-2 mb-3" data-bs-dismiss="offcanvas">
			<button type="button" class="btn btn-sm btn-success" (click)="statusClick(demoData, 'Converted')" *ngIf="!demoData?.status || demoData?.status != 'Done'">
				<i class="bi bi-calendar-check"></i> Mark Done!
			</button>
			<button type="button" class="btn btn-sm btn-success" (click)="setupNewAccount(demoData)" data-bs-toggle="modal" data-bs-target="#staticBackdrop2">
				<i class="bi bi-gear"></i> Setup New Account
			</button>
			<button type="button" class="btn btn-sm btn-danger" (click)="statusClick(demoData, 'Rejected')" *ngIf="demoData?.status != 'Invalid'">
				<i class="bi bi-eye-slash"></i> Rejected
			</button>
		</div> -->
	</div>
</div>

<div class="modal fade" id="frmBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="frmBackdropLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="frmBackdropLabel">Application Form</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body" style="min-height: 400px;">
        <div class="modal-scroll-wrapper">
				  <app-application-form [action]="btnClick"></app-application-form>
        </div>
			</div>
			<!-- <div class="modal-footer">
				<button type="button" class="col-2 btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
				<button type="button" class="col-2 btn btn-sm btn-primary" data-bs-dismiss="modal"
					(click)="btnClick = isEdit ? 'update' : 'save'; reloadData();">
					{{isEdit ? 'Update' : 'Save'}}
				</button>
			</div> -->
		</div>
	</div>
</div>

